var Util = {
    /** Used to get query string parameters **/
    getUrlParameters: function () {
        var vars = { length: 0 };
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            var hash = hashes[i].split('=');
            var key = hash[0];
            var value = hash[1];
            if (vars[key] === undefined) {
                vars[key] = value;
            } else if (Array.isArray(vars[key])) {
                vars[key].push(value);
            } else {
                vars[key] = [vars[key], value];
            }
            vars.length++;
        }
        return vars;
    },
    /**
     * Writes a cookie
     * @param {string} name name of cookie
     * @param {string} value cookie value
     */
    writeCookie: function(name, value) {
        document.cookie = name + "=" + value + "; path=/";
    },
    /**
     * Reads a cookie
     * @param {string} name 
     * @returns cookie value if exists
     */
    readCookie: function(name) {
        var i, c, ca, nameEQ = name + "=";
        ca = document.cookie.split(';');
        for (i = 0; i < ca.length; i++) {
            c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return '';
    },
    /**
     * Deletes a cookie
     * @param {string} name Name of cookie to delete
     */
    deleteCookie: function(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
};


export default Util;